import { Link } from "react-router-dom";
import { faqs } from "@/mocks/gossip";
import FaqAccordion from "@/components/base/FaqAccordion";

export default function HomeFaqSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100" aria-labelledby="home-faq-heading">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
        <div className="lg:col-span-4">
          <p className="font-label text-xs tracking-[0.2em] text-primary-600 uppercase mb-2">FAQ</p>
          <h2 id="home-faq-heading" className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-tight">
            关于看料吃瓜社，你可能想问
          </h2>
          <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
            内容来源、更新频率、投稿方式与更正流程，都在这里说明清楚。如果还有疑问，欢迎直接联系我们。
          </p>
          <Link
            to="/faq"
            className="mt-6 inline-flex items-center gap-1.5 px-4 py-2.5 text-sm font-label font-medium rounded-md bg-secondary-500 text-background-50 hover:bg-secondary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部常见问题
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="lg:col-span-8">
          <FaqAccordion items={faqs.slice(0, 4)} />
        </div>
      </div>
    </section>
  );
}